import { Component, ElementRef, HostListener, Input, OnChanges, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { McatalogConfigService } from 'src/app/services/catalogs-services/config-services/mcatalog-config.service';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';

@Component({
  selector: 'app-catalogs-config-colors-picker-card',
  templateUrl: './catalogs-config-colors-picker-card.component.html',
  styleUrls: ['./catalogs-config-colors-picker-card.component.scss']
})
export class CatalogsConfigColorsPickerCardComponent implements OnInit, OnChanges {

  @Input() primaryColor;
  @Input() secondaryColor;
  basicDataForm = new FormGroup({
    primaryColor: new FormControl({ value: '#000000', disabled: true }),
    secondaryColor: new FormControl({ value: '#ffffff', disabled: true })
  });
  editingLocked: boolean;
  updateCatalogConfigColorSubscription: Subscription;

  constructor(private eRef: ElementRef,
              private snackbarService: SnackBarService,
              private mcatalogConfigService: McatalogConfigService) {
    this.editingLocked = true;
  }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.primaryColor) {
      this.resetForm();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (this.eRef.nativeElement.contains(event.target)) {
    } else {
      if (event.path[0].className !== 'mat-option-text') {
        if (this.primaryColor && !this.editingLocked) {
          this.resetForm();
          this.lockEdition();
        }
      }
    }
  }

  public toggleEdition() {
    if (this.editingLocked) {
      this.unlockEdition();
    } else {
      this.submitForm();
      this.lockEdition();
    }
  }

  public submitForm() {
    this.updateCatalogConfigColorSubscription = this.mcatalogConfigService.updateMCatalogColor(this.basicDataForm.get('primaryColor').value, this.basicDataForm.get('secondaryColor').value).subscribe(
      (res) => {
        this.editingLocked = true;
        this.snackbarService.open('catalogs-page.snackbar messages.update services success', 'success');
        this.mcatalogConfigService.refreshMCatalogConfig();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
        this.mcatalogConfigService.refreshMCatalogConfig();
      }
    );
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      primaryColor: this.primaryColor,
      secondaryColor: this.secondaryColor,
    });
  }

  public unlockEdition() {
    this.basicDataForm.get('primaryColor').enable();
    this.basicDataForm.get('secondaryColor').enable();
    this.editingLocked = false;
  }

  public lockEdition() {
    this.basicDataForm.get('primaryColor').disable();
    this.basicDataForm.get('secondaryColor').disable();
    this.editingLocked = true;
  }
}
